"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.UseLocationCtaClickedAnalyticsEvent = exports.ScreenRentPortalAddressAnalyticsEvent = exports.ScreenOonHowYouPayAnalyticsEvent = exports.ScreenOonHowFlexWorksAnalyticsEvent = exports.ScreenHowDoYouPayAnalyticsEvent = exports.ScreenConfirmAddressAnalyticsEvent = exports.ScreenAddressUnitSelectionAnalyticsEvent = exports.ScreenAddressSelectionAnalyticsEvent = exports.PrefillsMatchUnitFailAnalyticsEvent = exports.PrefillsGetMatchResidentSuccAnalyticsEvent = exports.PrefillsGetMatchResidentErrorAnalyticsEvent = exports.PrefillsGetMatchResidentAnalyticsEvent = exports.HowDoYouPayCtaClickedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user views the 'Search for your property' screen in the Onboarding Flow
 */
var ScreenAddressSelectionAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_address_selection');
exports.ScreenAddressSelectionAnalyticsEvent = ScreenAddressSelectionAnalyticsEvent;
/**
 * Triggers when user sees the unit selection screen 'Which unit do you live in' in the Onboarding Flow
 */
var ScreenAddressUnitSelectionAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_address_unit_selection');
exports.ScreenAddressUnitSelectionAnalyticsEvent = ScreenAddressUnitSelectionAnalyticsEvent;
/**
 * Triggers when user views the 'Confirm your address' screen in the Onboarding Flow
 */
var ScreenConfirmAddressAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_confirm_address');
exports.ScreenConfirmAddressAnalyticsEvent = ScreenConfirmAddressAnalyticsEvent;
/**
 * Triggers when customer views the Flex Anywhere 'What's your address' screen in the Onboarding Flow
 */
var ScreenRentPortalAddressAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_rent_portal_address');
exports.ScreenRentPortalAddressAnalyticsEvent = ScreenRentPortalAddressAnalyticsEvent;
/**
 * Triggers when user views the Flex Anywhere Introduction Screen in the Onboarding Flow
 */
var ScreenOonHowYouPayAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_oon_how_you_pay');
exports.ScreenOonHowYouPayAnalyticsEvent = ScreenOonHowYouPayAnalyticsEvent;
/**
 * Triggers when user views 'How do you pay rent' screen in the Onboarding Flow
 */
var ScreenHowDoYouPayAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_how_do_you_pay');
exports.ScreenHowDoYouPayAnalyticsEvent = ScreenHowDoYouPayAnalyticsEvent;
/**
 * Triggers when user clicks "Continue" button on the Flex Anywhere 'How do you pay rent' screen in the Onboarding Flow containing the selected array of checkbox options
 */
var HowDoYouPayCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('how_do_you_pay_cta_clicked');
exports.HowDoYouPayCtaClickedAnalyticsEvent = HowDoYouPayCtaClickedAnalyticsEvent;
/**
 * Triggers when customer views the Flex Anywhere How It Works screen in the Onboarding Flow
 */
var ScreenOonHowFlexWorksAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_oon_how_flex_works');
exports.ScreenOonHowFlexWorksAnalyticsEvent = ScreenOonHowFlexWorksAnalyticsEvent;
/**
 * Triggers when customer clicks on 'Use location to improve results' in property search
 */
var UseLocationCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('use_location_cta_clicked');
exports.UseLocationCtaClickedAnalyticsEvent = UseLocationCtaClickedAnalyticsEvent;
/**
 * Triggers after customer clicks on 'Create Account' and we attempt to prefill the customer's property
 */
var PrefillsGetMatchResidentAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('prefills_get_match_resident');
exports.PrefillsGetMatchResidentAnalyticsEvent = PrefillsGetMatchResidentAnalyticsEvent;
/**
 * Triggers when we are not able to prefill the customer's property
 */
var PrefillsGetMatchResidentErrorAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('prefills_get_match_resident_error');
exports.PrefillsGetMatchResidentErrorAnalyticsEvent = PrefillsGetMatchResidentErrorAnalyticsEvent;
/**
 * Triggers when we were able to successfully prefill the customer's property
 */
var PrefillsGetMatchResidentSuccAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('prefills_get_match_resident_succ');
exports.PrefillsGetMatchResidentSuccAnalyticsEvent = PrefillsGetMatchResidentSuccAnalyticsEvent;
/**
 * Triggers when we are to match to a property but not able to prefill the customer's unit
 */
var PrefillsMatchUnitFailAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('prefills_match_unit_fail');
exports.PrefillsMatchUnitFailAnalyticsEvent = PrefillsMatchUnitFailAnalyticsEvent;
